<template>
  <div class="pending-orders-container">
    <el-card class="filter-card">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="订单编号">
          <el-input v-model="filterForm.orderSn" placeholder="请输入订单编号" clearable></el-input>
        </el-form-item>
        <el-form-item label="商家名称">
          <el-select
            v-model="filterForm.merchantId"
            filterable
            clearable
            placeholder="请选择商家名称"
            style="width: 220px">
            <el-option
              v-for="item in merchantOptions"
              :key="item.id"
              :label="item.companyName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称">
          <el-select
            v-model="filterForm.customerId"
            filterable
            clearable
            placeholder="请选择客户名称"
            style="width: 220px">
            <el-option
              v-for="item in customerOptions"
              :key="item.id"
              :label="item.companyName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filterForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleFilter">查询</el-button>
          <el-button @click="resetFilter">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <div class="table-header">
        <div class="header-left">
          <span class="title">待处理订单列表</span>
          <span class="count">共 {{ totalItems }} 条</span>
        </div>
      </div>
      
      <el-table
        :data="orderList"
        border
        v-loading="tableLoading"
        row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        style="width: 100%">
        <el-table-column
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          prop="orderSn"
          label="订单编号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          width="150">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商家名称"
          width="150">
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          width="150">
        </el-table-column>
        <el-table-column
          prop="testCount"
          label="样品数量"
          width="100">
        </el-table-column>
        <el-table-column
          prop="deviceName"
          label="测试仪器"
          width="150">
        </el-table-column>
        <el-table-column
          prop="actualPrice"
          label="订单金额"
          width="120">
          <template slot-scope="scope">
            {{ scope.row.actualPrice ? '¥' + scope.row.actualPrice.toFixed(2) : '¥0.00' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderStatusName"
          label="状态"
          width="120">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.orderStatus)">{{ getStatusText(scope.row.orderStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="expectedEndTime"
          label="预期完成时间"
          width="160">
        </el-table-column>
        <el-table-column
          label="操作"
          width="200"
          align="center"
          :fixed="viewport.width < 1200 ? false : 'right'"
        >
          <template slot-scope="scope">
            <div class="operation-buttons">
              <el-button type="primary" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
              <el-button 
                v-if="scope.row.isSettle === -1" 
                type="success" 
                size="mini" 
                @click="handleCompareTest(scope.row)">对比测试结果</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="pageSize"
          :total="totalItems"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'PendingOrders',
  data() {
    return {
      filterForm: {
        orderSn: '',
        merchantId: '',
        customerId: '',
        dateRange: []
      },
      tableLoading: false,
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      orderList: [],
      merchantOptions: [],
      customerOptions: [],
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }
  },
  computed: {
    // 判断是否为管理员用户
    isAdminUser() {
      const userRole = localStorage.getItem('userRole');
      const token = localStorage.getItem('token');
      // 验证用户角色和令牌
      return userRole === 'admin' && !!token;
    }
  },
  created() {
    this.fetchOrders()
    this.fetchMerchantList()
    this.fetchCustomerList()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.viewport.width = window.innerWidth
      this.viewport.height = window.innerHeight
    },
    // 获取商家列表
    async fetchMerchantList() {
      try {
        const res = await adminApi.getMerchantList()
        if (res && Array.isArray(res)) {
          this.merchantOptions = res
        } else {
          this.merchantOptions = []
        }
      } catch (error) {
        console.error('获取商家列表失败:', error)
        this.merchantOptions = []
      }
    },
    // 获取客户列表
    async fetchCustomerList() {
      try {
        const res = await adminApi.getCustomerList()
        if (res && Array.isArray(res)) {
          this.customerOptions = res
        } else {
          this.customerOptions = []
        }
      } catch (error) {
        console.error('获取客户列表失败:', error)
        this.customerOptions = []
      }
    },
    async fetchOrders() {
      this.tableLoading = true
      try {
        // 构建请求参数
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          orderSn: this.filterForm.orderSn || undefined,
          merchantId: this.filterForm.merchantId || undefined,
          customerId: this.filterForm.customerId || undefined,
          orderStatus: 'TESTED',
          isDispute: 1,
          isSettle: -1
        }
        
        // 添加日期范围参数
        if (this.filterForm.dateRange && this.filterForm.dateRange.length === 2) {
          params.startDate = this.filterForm.dateRange[0]
          params.endDate = this.filterForm.dateRange[1]
        }
        
        const response = await adminApi.getOrderListByPage(params)
        
        if (response && response.data && response.data.code === 200) {
          // 处理数据为树形结构
          this.orderList = (response.data.data || []).map(order => {
            if (order.subOrder) {
              // 确保子订单有唯一的id
              const subOrder = {
                ...order.subOrder,
                id: order.subOrder.id || `sub_${order.id}`,
                isSubOrder: true,
                isSettled: order.isSettled // 确保子订单也继承父订单的isSettled属性
              }
              return {
                ...order,
                id: order.id || `parent_${order.orderSn}`,
                children: [subOrder]
              }
            }
            return {
              ...order,
              id: order.id || `parent_${order.orderSn}`
            }
          })
          console.log('处理后的数据:', this.orderList)
          this.totalItems = response.data.count || 0
        } else {
          this.orderList = []
          this.totalItems = 0
          this.$message.error(response.msg || '获取订单列表失败')
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
        this.orderList = []
        this.totalItems = 0
        this.$message.error('获取订单列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    handleFilter() {
      this.currentPage = 1
      this.fetchOrders()
    },
    resetFilter() {
      this.filterForm = {
        orderSn: '',
        merchantId: '',
        customerId: '',
        dateRange: []
      }
      this.currentPage = 1
      this.pageSize = 10
      this.fetchOrders()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchOrders()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchOrders()
    },
    // 获取状态类型（用于标签颜色）
    getStatusType(status) {
      const statusMap = {
        NOT_SHIPPED: 'info',
        IN_TRANSIT: 'primary',
        TESTING: 'warning',
        TESTED: 'success',
        COMPLETED: 'success',
        DISPUTE: 'danger',
        UNSETTLED: 'warning',
        RETURN: 'info',
        FORWARD: 'info',
        CANCEL: 'danger',
        EXPIRING: 'danger',
        RETESTING: 'warning',
        RETESTED: 'success',
        DISPUTED: 'success',
      }
      return statusMap[status] || 'info'
    },
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        NOT_SHIPPED: '未邮寄',
        IN_TRANSIT: '在途',
        TESTING: '测试中',
        TESTED: '已测试',
        COMPLETED: '已完成',
        DISPUTE: '争议中',
        DISPUTED: '已处理争议',
        RETESTING: '复测中',
        RETESTED: '已复测',
        UNSETTLED: '未结算',
        RETURN: '回寄',
        FORWARD: '转寄',
        CANCEL: '已取消',
      }
      return statusMap[status] || '未知状态'
    },
    // 查看订单详情
    handleDetail(row) {
      this.$router.push(`/admin/orders/detail/${row.id}`)
    },
    // 对比测试结果
    handleCompareTest(row) {
      this.$router.push(`/admin/orders/compare/${row.id}`)
    },
    // 提出争议/复测
    handleRetestDispute(row) {
      this.$confirm('请选择申请类型', '提示', {
        confirmButtonText: '提出争议',
        cancelButtonText: '申请复测',
        type: 'warning',
        distinguishCancelAndClose: true,
        callback: (action) => {
          if (action === 'confirm') {
            // 提出争议 - 跳转到争议提交表单
            this.$router.push({
              path: `/admin/orders/management/${row.id}`,
              query: {
                step: 'SUBMIT_DISPUTE',
                action: 'dispute'
              }
            });
          } else if (action === 'cancel') {
            // 申请复测 - 跳转到复测上传页面
            this.$router.push({
              path: `/admin/orders/management/${row.id}`,
              query: {
                step: 'SUBMIT_RETEST',
                action: 'retest'
              }
            });
          }
        }
      })
    },
    // 转寄样品
    handleTransferShip(row) {
      // 如果订单状态为在途，则显示转寄表单
      if (row.orderStatus === 'IN_TRANSIT') {
        // 创建临时变量存储转寄说明
        let transferRemark = '';
        
        this.$confirm('', '转寄样品', {
          confirmButtonText: '提交',
          cancelButtonText: '取消',
          showCancelButton: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          distinguishCancelAndClose: true,
          customClass: 'transfer-dialog',
          dangerouslyUseHTMLString: true,
          message: `
            <div class="transfer-form">
              <div class="form-item">
                <label>项目名称:</label>
                <span>${row.projectName || '暂无'}</span>
              </div>
              <div class="form-item">
                <label>订单编号:</label>
                <span>${row.orderSn || '暂无'}</span>
              </div>
              <div class="form-item">
                <label>仪器名称:</label>
                <span>${row.deviceName || '暂无'}</span>
              </div>
              <div class="form-item">
                <label>测试价格:</label>
                <span>¥${row.actualPrice ? row.actualPrice.toFixed(2) : '0.00'}</span>
              </div>
              <div class="form-item" style="align-items: center;">
                <label>转寄说明:<span style="color: #f56c6c; margin-left: 4px;">*</span></label>
                <div style="flex: 1; width: 100%;">
                  <textarea id="transferRemarkTextarea" 
                    placeholder="请输入转寄说明"
                  ></textarea>
                </div>
              </div>
            </div>
          `
        }).then(() => {
          // 提交前验证转寄说明是否已填写
          const transferRemarkValue = document.getElementById('transferRemarkTextarea')?.value || '';
          
          if (!transferRemarkValue.trim()) {
            this.$message.error('请填写转寄说明');
            return Promise.reject('转寄说明不能为空');
          }
          
          // 提交后调用原来的接口
          const params = {
            id: row.id,
            orderStatus: 'FORWARD',
            remarks: transferRemarkValue
          }
          adminApi.updateOrderStatus(params)
            .then(res => {
              if (res) {
                this.$message.success('转寄操作成功')
                this.fetchOrders()
              } else {
                this.$message.error(res.data?.msg || '操作失败')
              }
            })
            .catch(error => {
              console.error('更新订单状态失败:', error)
              this.$message.error('转寄操作失败')
            })
        }).catch(() => {
          this.$message.warning('已取消操作')
        })
      } else {
        // 其他状态跳转到转寄页面
        this.$router.push({
          path: `/admin/orders/management/${row.id}`,
          query: {
            step: 'FORWARD',
            action: 'forward'
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.pending-orders-container {
  padding: 20px;
}
.filter-card {
  margin-bottom: 20px;
}
.filter-form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
}

.filter-form .el-form-item {
  min-width: 240px;
  margin-bottom: 10px;
  margin-right: 0;
}

/* 创建时间选择器样式 */
.filter-form .el-date-editor {
  width: 360px !important;
}

/* 按钮组样式 */
.filter-form .el-form-item:last-child {
  min-width: 180px;
}

.table-card {
  margin-bottom: 20px;
}
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.header-left {
  display: flex;
  align-items: center;
}
.title {
  font-size: 18px;
  font-weight: bold;
  margin-right: 10px;
}
.count {
  font-size: 14px;
  color: #666;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
.operation-buttons {
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
  justify-content: center;
  white-space: nowrap;
}

/* 操作按钮样式 */
.operation-buttons .el-button {
  margin: 3px;
  min-width: 90px;
  padding: 6px 12px;
}

/* 转寄表单样式 */
.transfer-dialog .el-message-box {
  width: 500px !important;
  max-width: 95vw;
  border-radius: 8px;
  overflow: hidden;
}

.transfer-dialog .el-message-box__header {
  padding: 15px 20px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
  position: relative;
}

.transfer-dialog .el-message-box__title {
  font-size: 18px;
  color: #303133;
  font-weight: bold;
}

.transfer-dialog .el-message-box__headerbtn {
  top: 16px;
}

.transfer-dialog .el-message-box__content {
  padding: 20px;
}

.transfer-dialog .el-message-box__btns {
  padding: 10px 20px 15px;
  border-top: 1px solid #f0f0f0;
}

.transfer-dialog .el-message-box__btns button {
  min-width: 80px;
  padding: 8px 15px;
  font-size: 14px;
}

.transfer-dialog .el-button--primary {
  background-color: #409EFF;
  border-color: #409EFF;
}

.transfer-form {
  padding: 0;
}

.transfer-form .form-item {
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  border-bottom: 1px dashed #ebeef5;
  padding-bottom: 12px;
}

.transfer-form .form-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.transfer-form .form-item label {
  width: 90px;
  text-align: right;
  padding-right: 15px;
  font-weight: bold;
  line-height: 32px;
  color: #606266;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.transfer-form .form-item span {
  flex: 1;
  line-height: 32px;
  color: #303133;
  font-size: 14px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

#transferRemarkTextarea {
  width: 100%;
  min-height: 150px;
  padding: 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  resize: vertical;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #303133;
  transition: all 0.3s;
  margin-top: 5px;
  box-sizing: border-box;
}

#transferRemarkTextarea:focus {
  outline: none;
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

#transferRemarkTextarea::placeholder {
  color: #C0C4CC;
  font-size: 14px;
}

/* 适配移动仪器时的按钮样式 */
@media screen and (max-width: 768px) {
  .operation-buttons {
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
  }
  
  .operation-buttons .el-button {
    margin: 3px;
    min-width: 80px;
    padding: 6px 10px;
  }
}

.expanded {
  color: #409EFF;
  font-weight: bold;
}

.sub-order-title {
  font-weight: bold;
  color: #409EFF;
}

/* 子订单容器样式 */
.sub-order-container {
  margin: 10px 0;
}

.sub-order-card {
  margin: 0 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}

.sub-order-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
}

.parent-order-sn {
  color: #606266;
  font-size: 14px;
}

/* 描述列表样式 */
.el-descriptions {
  margin-top: 10px;
}

.el-descriptions-item__label {
  width: 100px;
  color: #606266;
  font-weight: bold;
}

.el-descriptions-item__content {
  color: #303133;
}

/* 子订单行样式 */
.el-table__row--level-1 {
  background-color: #f5f7fa;
}

.el-table__row--level-1 td {
  padding-left: 50px !important;
}
</style> 